import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as ACT from './actions'
import { createSelector } from 'reselect'
import { Company } from './Company'
import { PageTitle } from 'components/common/PageTitle'
import { useParams } from 'react-router-dom'

const selectCompany = createSelector([state => state.company], company => {
  return company.company
})

const selectPipeline = createSelector([state => state.company], company => {
  return company.companyPipeline
})

const selectCompanyStats = createSelector([state => state.company], company => {
  return company.companyClientStats
})

const CompanyContainer = () => {
  const dispatch = useDispatch()
  const params = useParams()

  const company = useSelector(state => selectCompany(state.company))
  const pipeline = useSelector(state => selectPipeline(state.company))
  const stats = useSelector(state => selectCompanyStats(state.company))

  useEffect(() => {
    dispatch({
      type: ACT.COMPANY_FETCH_REQUESTED,
      payload: {
        id: params.id
      }
    })
  }, [dispatch, params.id])

  return (
    <>
      <Company company={company} pipeline={pipeline} stats={stats} />
      <PageTitle detail={company?.name} />
    </>
  )
}

export default CompanyContainer
